/**
 * Product Single - Variant SKU Filter Logic (Physical DOM Detachment)
 * Full File Replacement
 */
(function () {
  let activeVariantId = null;

  // ── 1. Helpers ────────────────────────────────────────────────────────
  function parseAlt(altText) {
    if (!altText || !altText.includes('|')) return null;
    const prefix = altText.split('|')[0];
    const lastUnderscore = prefix.lastIndexOf('_');
    if (lastUnderscore === -1) return null;
    return {
      sku: prefix.substring(0, lastUnderscore),
      serial: parseInt(prefix.substring(lastUnderscore + 1), 10)
    };
  }

  function getVariantData() {
    const el = document.querySelector('variant-radios script[type="application/json"], variant-selects script[type="application/json"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  // Gets or creates a hidden storage div to keep our slides safe when not needed
  function getStorage(wrapper, type) {
    const container = wrapper.parentElement;
    let storage = container.querySelector(`.media-storage-${type}`);
    if (!storage) {
      storage = document.createElement('div');
      storage.className = `media-storage-${type}`;
      storage.style.display = 'none'; // Keep them hidden
      container.appendChild(storage);
    }
    return storage;
  }

  // ── 2. Core Filtering Logic ───────────────────────────────────────────
  function applyFilterForVariantId(variantId) {
    if (!variantId) return;
    activeVariantId = variantId;

    const variants = getVariantData();
    if (!variants) return;
    const variant = variants.find(v => v.id === variantId);
    if (!variant || !variant.sku) return;

    const sku = variant.sku;

    const mainEl = document.querySelector('.js-media-list');
    const subEl = document.querySelector('.js-media-sublist');
    
    if (!mainEl || !subEl) return;

    // 1. Destroy Swiper instances so we can safely edit the HTML
    if (mainEl.swiper) mainEl.swiper.destroy(true, true);
    if (subEl.swiper) subEl.swiper.destroy(true, true);

    const mainWrapper = mainEl.querySelector('.swiper-wrapper');
    const subWrapper = subEl.querySelector('.swiper-wrapper');
    
    const mainStorage = getStorage(mainWrapper, 'main');
    const subStorage = getStorage(subWrapper, 'sub');

    // 2. Restore all slides from storage back to the wrappers
    while (mainStorage.firstChild) mainWrapper.appendChild(mainStorage.firstChild);
    while (subStorage.firstChild) subWrapper.appendChild(subStorage.firstChild);

    // 3. Filter and Sort function
    function processWrapper(wrapper, storage) {
      const slides = Array.from(wrapper.querySelectorAll('.swiper-slide'));
      let matched = [];
      let unmatched = [];

      slides.forEach(slide => {
        const img = slide.querySelector('img');
        let isMatch = false;
        
        // Remove old classes that confuse Swiper
        slide.classList.remove('swiper-slide-active', 'swiper-slide-next', 'swiper-slide-prev');
        slide.style.display = ''; 

        if (img) {
          const parsed = parseAlt(img.getAttribute('alt'));
          if (parsed && parsed.sku === sku) {
            isMatch = true;
            matched.push({ slide, serial: parsed.serial });
          }
        }
        
        if (!isMatch) unmatched.push(slide);
      });

      // If we found matching slides for this SKU
      if (matched.length > 0) {
        // Move unmatched slides to the hidden storage div
        unmatched.forEach(slide => storage.appendChild(slide));
        
        // Sort the matched slides by serial number
        matched.sort((a, b) => a.serial - b.serial);
        
        // Append them back to the wrapper in the correct order
        matched.forEach(item => wrapper.appendChild(item.slide));
      }
    }

    // Process both the main images and the thumbnails
    processWrapper(mainWrapper, mainStorage);
    processWrapper(subWrapper, subStorage);

    // 4. Re-initialize Swipers using the native theme functions
    // We call subSliderInit FIRST so the thumbnails exist for sliderInit to link to!
    try {
      if (typeof subSliderInit === 'function') subSliderInit();
      if (typeof sliderInit === 'function') sliderInit();
      if (typeof updatethumbnail === 'function') updatethumbnail();
    } catch (e) {
      console.warn("Swiper re-init failed", e);
    }
  }

  // ── 3. Initialization & Watchers ──────────────────────────────────────
  let initTimer;
  function init() {
    clearTimeout(initTimer);
    initTimer = setTimeout(() => {
      // Find Initial Variant ID
      const urlParams = new URLSearchParams(window.location.search);
      let vId = urlParams.get('variant') ? parseInt(urlParams.get('variant'), 10) : null;
      if (!vId) {
        const variants = getVariantData();
        if (variants && variants.length > 0) vId = variants[0].id;
      }
      
      applyFilterForVariantId(vId);
    }, 150);

    // Watch for Shopify's variant change event
    document.addEventListener('variant:change', function(event) {
      if (event.detail && event.detail.variant) {
        applyFilterForVariantId(event.detail.variant.id);
      }
    });

    // ── THE CRITICAL FETCH WATCHER ──
    // When global.js runs fetch() and replaces the HTML, we must re-filter.
    const mediaContainer = document.querySelector('.product-section') || document.body;
    const observer = new MutationObserver((mutations) => {
      let htmlReplaced = false;
      mutations.forEach(mutation => {
        if (mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && (node.classList.contains('js-media-list') || node.querySelector('.js-media-list'))) {
              htmlReplaced = true;
            }
          });
        }
      });
      
      if (htmlReplaced && activeVariantId) {
        // Wait 50ms for global.js to finish its native sliderInit, then overwrite it
        setTimeout(() => {
           applyFilterForVariantId(activeVariantId);
        }, 50); 
      }
    });

    observer.observe(mediaContainer, { childList: true, subtree: true });
  }

  // Execution
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);

})();